const SETTINGS = {
  DEBUG: false,
  CLOUDINARY_ROOT_URL: '',
  CLOUDINARY_ALT_TEXTS: {},
};

export default SETTINGS;
